module.exports = __webpack_public_path__ + "img/man-rest.2bdec765.png";